import { EditableBadge, type BadgeProps, type BadgeVariant } from '@chatsdet/ui';
import { useUpdateTask } from '../hooks/useTasks';
import { PRIORITY_OPTIONS, PRIORITY_LABELS } from '../constants';
import type { AgentTaskDetail } from '../types';

const PRIORITY_VARIANTS: Record<string, BadgeVariant> = {
  '0': 'outline',
  '1': 'warning',
  '2': 'destructive',
};

interface PriorityEditableBadgeProps {
  task: AgentTaskDetail;
  onSuccess?: () => void;
  size?: BadgeProps['size'];
}

export function PriorityEditableBadge({ task, onSuccess, size }: PriorityEditableBadgeProps) {
  const updateTask = useUpdateTask();

  const handleChange = (value: string) => {
    const priority = parseInt(value, 10);
    if (priority === task.priority) return;
    updateTask.mutate({ id: task.id, priority }, { onSuccess });
  };

  return (
    <EditableBadge
      value={String(task.priority)}
      options={PRIORITY_OPTIONS}
      onChange={handleChange}
      getVariant={(value) => PRIORITY_VARIANTS[value]}
      formatLabel={(value) => PRIORITY_LABELS[parseInt(value, 10)] ?? 'Normal'}
      size={size}
      isLoading={updateTask.isPending}
      aria-label={`Change priority for task: ${task.title}`}
    />
  );
}
